<template>
  <div>
    <el-form-item class="forceAnswer">
      <el-switch v-model="forceAnswer" class="form-dark blueSwitch"></el-switch>
      <label>{{ $t('answerList.强制作答') }}</label>
      <el-tooltip class="item" effect="dark" placement="top" :visible-arrow="false">
        <div slot="content">
          {{ $t('answerList.无法跳过答题') }}
        </div>
        <img class="tip-icon" :src="require('@/svg/tip.svg')" />
      </el-tooltip>
    </el-form-item>
    <div class="answerList">
      <el-form-item class="input-ground" :label="$t('answerList.题型')" :error="errorTitle">
        <el-input
          type="textarea"
          v-model="answerTitle"
          class="addInputLongItem"
          :placeholder="$t('answerList.请输入')"
          show-word-limit
          maxlength="255"
          @blur="valueChange"
          :autosize="true"
          resize="none"
        ></el-input>
        <el-select
          :placeholder="$t('answerList.请选择')"
          class="addInputLongItem selectItem"
          v-model="choose"
          @change="chageOptions"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="$t(`answerList.${item.label}`)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="choose === 0">
        <draggable
          v-model="serialItem"
          :sort="draggableSort"
          draggable=".moreAnswerItem"
          @start="startDrag"
          ghost-class="ghost"
          @end="removeMoves"
        >
          <el-form-item
            v-for="(item, index) of serialItem"
            class="moreAnswerItem"
            :key="index"
            @mouseenter="hovers(index)"
            @mouseleave="removeHove()"
          >
            <div class="item-options">
              <i class="icon-dot"></i>
              <a
                :title="$t('answerList.删除')"
                href="javascript:;"
                class="icon icon-clear addRadioRemove"
                v-if="isShowDelChoose"
                @click="removeMoreanswer(item,index)"
              ></a>
            </div>
            <label class="num-label">{{ item.number }}</label>
            <el-input
              :placeholder="$t('answerList.请输入')"
              class="addRadioInput"
              maxlength="150"
              v-model="item.item"
              show-word-limit
              @blur="chooseChange(index)"
            >
            </el-input>
            <el-radio
              :label="item.number"
              class="addRadio"
              v-model="correctTips"
              @change="changeSelectOnly(item)"
              >{{ $t('addOrEdit.正确答案') }}</el-radio
            >
            <label class="error-select">{{ item.error }}</label>
          </el-form-item>
        </draggable>
      </div>
      <div>
        <draggable
          v-model="serialItem"
          :sort="draggableSort"
          draggable=".moreAnswerItem"
          @end="removeMoves"
          @start="startDrag"
          ghost-class="ghost"
          v-if="choose === 1"
        >
          <el-form-item
            v-for="(item, index) of serialItem"
            :key="index"
            class="moreAnswerItem"
            @mouseenter="hovers(index)"
            @mouseleave="removeHove()"
          >
            <div class="item-options">
              <i class="icon-dot"></i>
              <a
                :title="$t('answerList.删除')"
                href="javascript:;"
                class="icon icon-clear addRadioRemove"
                v-if="isShowDelChoose"
                @click="removeMoreanswer(item,index)"
              ></a>
            </div>
            <label class="num-label">{{ item.number }}</label>
            <el-input
              v-model="item.item"
              :placeholder="$t('answerList.请输入')"
              class="addCheckedInput"
              maxlength="150"
              show-word-limit
              @blur="chooseChange(index)"
            >
            </el-input>
            <el-checkbox
              class="addRadio"
              :label="item.number"
              :key="item.number"
              v-model="correctChecked"
              @change="changeSelect(item)"
              >{{ $t('addOrEdit.正确答案') }}</el-checkbox
            >
            <label class="error-select">{{ item.error }}</label>
          </el-form-item>
        </draggable>
      </div>

      <div class="m-t-8 add-choose" v-if="serialItem.length < 10">
        <a type="button" class="link-blue more-blue" @click="addMoreList" href="javascript:;">
          <i class="icon-add"></i>{{ $t('answerList.添加选项') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import drag from '@/components/toolList/answer/drag';

export default {
  components: {
    draggable
  },
  mixins: [drag],
  props: {
    answer: {
      type: Object,
      default: null
    },
    serial: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    correct: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      options: [
        {
          label: '单选',
          value: 0
        },
        {
          label: '多选',
          value: 1
        }
      ],
      showAddSerial: true,
      draggableSort: false, //是否允许移动
      isShowDelChoose: false,
      choose: 0,
      showSelect: true,
      answerTitle: '',
      serialItem: [
        {
          number: 'A',
          item: '',
          error: '',
          successState: false
        },
        {
          number: 'B',
          item: '',
          error: '',
          successState: false
        }
      ],
      correctTips: '',
      isShowMove: '',
      correctChecked: [],
      errorTitle: '',
      forceAnswer: false //强制作答
    };
  },
  computed: {},
  created() {},
  watch: {
    answer: {
      immediate: true,
      handler(value) {
        this.choose = value.choose;
        this.correctTips = value.correct[0] ? value.correct[0] : '';
        this.correctChecked = value.correct;
        console.log(this.correctChecked, 'answer watch');
        console.log(this.correctTips, 'answer watch correctTips');
        console.log(value, 'correctChecked .... answer watch');
      }
    },
    serial: {
      immediate: true,
      handler(value) {
        console.log(value, 'serial watch');
        //value.checked = this.correctChecked.includes(value.number);
        //console.log(this.choose, '选择的');
        this.serialItem = value;
        console.log(this.serialItem, 'this.serialItem serial watch');
        this.isShowDelChoose = value.length > 2 ? true : false;
      }
    },
    title: {
      immediate: true,
      handler(value) {
        console.log(value, 'title change');
        this.answerTitle = value;
        this.$emit('titleChange', value);
      }
    },
  },
  methods: {
    changeSelect(item) {
      item.successState = !item.successState;
      console.log(this.serialItem, 'this.serialItem changeSelect');
    },
    changeSelectOnly(item){
      item.successState = !item.successState;
      this.correctTips = item.number;
      this.serialItem.forEach(serial => {
        if(serial.number !== item.number){
          serial.successState = false;
        }
      });
      console.log(this.serialItem, 'this.serialItem changeSelect');
    },
    valueChange() {
      let message = this.$t('answerList.请输入题干');
      if (this.answerTitle === '') {
        this.errorTitle = message;
      } else {
        this.errorTitle = '';
      }
    },
    chooseChange(index) {
      this.serialItem.forEach((item, d) => {
          if (d === index && item.item === '') {
            item.error = this.$t('answerList.请输入选项');
          } else if (item.error !== '' && item.item !== '') {
            item.error = '';
          }
      });
      this.$forceUpdate();
      this.$emit("update:serial", this.serialItem);
      console.log(this.serialItem, 'this.serialItem');
    },
    addMoreList() {
      //if(this.moreAnswerSerial.length < 11){
      let numberChar = String.fromCharCode(this.serialItem.length + 65);
      //this.moreAnswerSerial.push(numberChar);
      this.serialItem.push({
        number: numberChar,
        item: '',
        checked: false,
        error: '',
        successState: false
      });
      if (this.serialItem.length > 2) {
        this.isShowDelChoose = true;
      }
      console.log(this.serialItem, '添加serialItem');
      let checked = [];
      this.serialItem.forEach(element => {
        if(element.successState){
          checked.push(element.number);
        }
      })
      this.correctChecked = checked;
      this.$emit('update:serial', this.serialItem);
      // } else {
      //   this.showAddSerial = false;
      // }
    },
    removeMoreanswer(item, index) {
      console.log(item, 'removeMoreanswer');
      if(item.number == this.correctTips){
        this.correctTips = '';
      }
      //this.correctChecked = this.correctChecked.filter(value => value !== item.number);
      console.log(this.correctTips, 'this.correctTips');
      //console.log(this.correctChecked, 'this.correctChecked');
      this.serialItem.splice(index, 1);
      console.log(this.serialItem, 'this.serialItem');
      
      let moreItem = [];
      this.serialItem.forEach((element, i) => {
        element.number = String.fromCharCode(i + 65);
        moreItem.push(element);
      });
      this.serialItem = moreItem;
      console.log(moreItem, 'moreItem');
      let checked = [];
      this.serialItem.forEach(element => {
        if(element.successState){
          checked.push(element.number);
        }
      })
      this.correctChecked = checked;
      console.log(checked, 'checked');
      if (this.serialItem.length < 3) {
        this.isShowDelChoose = false;
      }
      
      this.$emit('update:serial', this.serialItem);
    },
    chageOptions() {
      let optionsChoose = {
        choose: this.choose
      };
      console.log(optionsChoose, 'optionsChoose');
      this.isShowDelChoose = this.serialItem.length > 2? true : false;
      this.correctTips = '';
      this.correctChecked = [];
      this.$emit('changeOptions', optionsChoose);
    },
    hovers(index) {
      console.log(index, 'hover index');
      this.isShowMove = index;
    },
    removeHove() {
      this.isShowMove = '';
    },
    addMove() {
      this.draggableSort = true;
    }
  }
};
</script>
<style scoped lang="scss">
.error-select {
  color: #f56c6c;
  font-size: 12px;
}
::v-deep .el-textarea__inner {
  background: $back-answer-color;
  color: $white-color;
  border-color: #525366;
}
.link-blue {
  color: $white-color;
  text-decoration: none;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  padding: 0 15px;
  border-radius: 8px;
  margin-right: 15px;
  font-size: 12px;
}
.input-ground {
  color: $white-color;
  ::v-deep .el-form-item__label {
    width: 60px;
  }
}
.input-ground ::v-deep .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.addInputLongItem {
  width: 360px;
  margin-right: 7px;
  margin-left: 7px;
  ::v-deep .el-textarea__inner {
    padding: 8px 20px 8px 15px;
  }
}
.addRadioInput {
  width: 360px;
}
.addCheckedInput {
  width: 360px;
}
::v-deep .el-radio-group {
  width: 100%;
}
.moreAnswerItem {
  cursor: move;
  ::v-deep .el-radio,
  ::v-deep .el-checkbox {
    border: 1px solid #525366;
    width: 93px;
    height: 35px;
    line-height: 35px;
    margin-left: 16px;
    border-radius: 4px;
  }
  ::v-deep .el-checkbox__label {
    color: #fff;
  }
  ::v-deep .el-radio.is-checked,
  ::v-deep .el-checkbox.is-checked {
    border-radius: 4px;
    opacity: 1;
    background: #87d48e !important;
    border: 1px solid #87d48e !important;
  }
  ::v-deep .el-radio__input.is-checked + .el-radio__label,
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #fff !important;
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner,
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #ffffff !important;
    border-color: #fff !important;
  }
  ::v-deep .el-radio__input.is-checked {
    content: url('../../../svg/check-radio.svg');
    display: inline-block;
    vertical-align: middle;
  }
  ::v-deep .el-checkbox__input.is-checked {
    content: url('../../../svg/check-box.svg');
    display: inline-block;
    vertical-align: middle;
  }
}
[data-theme='Orange'] .moreAnswerItem {
  ::v-deep .el-radio,
  ::v-deep .el-checkbox {
    border: 1px solid #dcdfe6;
  }
}
.icon {
  display: inline-block;
  height: 18px;
  width: 18px;
  vertical-align: middle;
  background-repeat: no-repeat;
  margin-left: 10px;
  color: $white-color;
}
.icon-clear {
  background: url(../../../svg/icon-del.svg);
  width: 11px;
  height: 11px;
  &:hover,
  &:active {
    background: url(../../../svg/icon-del-red.svg);
  }
}
.icon-move-up {
  background: url(../../../svg/icon/icon-move-down.svg);
}
.icon-move-down {
  background: url(../../../svg/icon/icon-move-up.svg);
}
.numberChar {
  display: inline-block;
  width: 23px;
  height: 23px;
  color: $white-color;
}
.selectItem {
  width: 100px;
}

.ticketsList {
  width: 93%;
}
.icon-move {
  background: url(../../../svg/drag.svg);
  width: 10px;
  height: 14px;
}
.tips-title ::v-deep .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.add-choose {
  color: $white-color;
  display: flex;
  text-align: left;
  margin-left: 35px;
}
.moreAnswerItem {
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.forceAnswer {
  color: $white-color;
  padding-left: 70px;
}
[data-theme='Orange'] .forceAnswer {
  color: #606266;
}
.questionnaire-new .forceAnswer ::v-deep .el-form-item__content {
  text-align: left;
  line-height: 35px;
}
.blueSwitch {
  margin-right: 7px;
}
.item-options {
  display: flex;
  margin-right: 7px;
  width: 43px;
  justify-content: flex-end;
}
.icon-dot {
  background-image: url('../../../svg/icon-dot.svg');
  width: 10px;
  height: 10px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.ghost {
  background: rgba(57, 134, 238, 0.4);
  .icon-dot {
    background-image: url('../../../svg/icon-dot-blue.svg');
  }
}
.icon-add {
  background-image: url('../../../svg/icon-add-question.svg');
  width: 12px;
  height: 12px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
}
[data-theme='Orange'] .icon-add {
  background-image: url('../../../svg/icon-add-orange.svg');
}
.more-blue {
  display: flex;
  align-items: center;
}
.answerList {
  border-radius: 8px;
  background-color: rgba(92, 97, 124, 0.3);
  padding-top: 30px;
  padding-bottom: 22px;
}
[data-theme='Orange'] .answerList {
  background-color: rgba(245, 245, 245, 1);
}
.num-label {
  color: #fff;
  margin-right: 7px;
  width: 10px;
}
[data-theme='Orange'] .num-label {
  color: #3e3f41;
}
::v-deep .el-textarea .el-input__count{
  bottom: 6px;
}
.moreAnswerItem ::v-deep .el-input__inner{
  padding-right: 57px;
}
</style>
<style lang="scss">
.el-select-dropdown__item {
  color: $white-color;
}
</style>
